import { render, staticRenderFns } from "./athenaeum-panel.vue?vue&type=template&id=407927df&"
var script = {}
import style0 from "../../../assets/styles/panels/_AthenaeumPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports